import { useEffect, useRef } from 'react';
import { tg } from './telegram';

/** Shows Telegram's back button while the screen is open; hides it when handler is null. */
export function useTelegramBack(handler: (() => void) | null) {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => {
    const bb = tg?.BackButton;
    if (!bb) return;
    if (!handler) {
      bb.hide();
      return;
    }
    const cb = () => ref.current?.();
    bb.onClick(cb);
    bb.show();
    return () => {
      bb.offClick(cb);
      bb.hide();
    };
  }, [!!handler]);
}
